"use strict";
import R from "ramda";
import { hoverFor } from "../../annotation/bounding_box";
import { SET_HOVERED_COMPONENT } from "../actions";
export default function setHover(hoveredComponent = {}, action) {
  switch (action.type) {
    case SET_HOVERED_COMPONENT: {
      const { views, mousePos, cropping } = action;
      const getHoverInfo = hoverFor(mousePos);
      const addHoverInfo = (view) => {
        const { typeID, dragPoints } = view;
        const { hovered, dragPointIndex } = getHoverInfo(typeID, dragPoints);
        return {
          viewID: view.guid,
          hovered,
          dragPointIndex
        };
      };
      const isHovered = (hoverInfo) => hoverInfo.hovered;
      const isCropping = (cropOn) => (view) => cropOn ? view.typeID === "Crop" : view.typeID !== "Crop";
      const moreThanOne = R.pipe(
        R.length,
        R.gt(R.__, 1)
        // eslint-disable-line no-underscore-dangle
      );
      const pickBest = R.reduce((currentBest, hoverInfo) => {
        if (currentBest.viewID && currentBest.viewID !== hoverInfo.viewID) {
          return currentBest;
        }
        return hoverInfo;
      }, hoveredComponent);
      return R.pipe(
        R.filter(isCropping(cropping)),
        R.map(addHoverInfo),
        R.filter(isHovered),
        R.ifElse(moreThanOne, pickBest, R.head)
      )(R.values(views)) || {};
    }
    default:
      return hoveredComponent;
  }
}
